import {
  AbstractControl,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';

export function validateFormGroup(formGroup: UntypedFormGroup) {
  for (const i of Object.keys(formGroup.controls)) {
    formGroup.controls[i].markAsDirty();
    formGroup.controls[i].updateValueAndValidity();
  }

  for (const i of Object.keys(formGroup.controls)) {
    if (!formGroup.controls[i].valid && !formGroup.controls[i].disabled) {
      return false;
    }
  }

  return true;
}

export function nonEmptyValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value || !control.value.trim()) {
    return {
      forbiddenName: { value: control.value },
    };
  }
  return null;
}

export function usernameValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value || !control.value.match(/^[A-z][A-z0-9]{3,16}$/)) {
    return {
      forbiddenName: { value: control.value },
    };
  }
  return null;
}

export function passwordValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value || !control.value.match(/^[A-z0-9_/.]{8,20}$/)) {
    return {
      forbiddenName: { value: control.value },
    };
  }
  return null;
}

export function letterAndNumberValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value || !control.value.match(/^(?=.*[a-zA-Z])(?=.*\d).+$/)) {
    return {
      pattern: { value: control.value },
    };
  }
  return null;
}
